import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import SlideToggle from 'react-slide-toggle';
import { compose } from 'redux'
import { getCategoryItems } from "../../../actions/category";
import { filterDefault, closeDefault } from '../../common/MangoIcons'
import _ from 'lodash';

import { getAllSearchFilters, setSearchFilters } from "../../../actions/searchFilters"
import { toast } from 'react-toastify';

const defaultFilters = {
    selectedBrands: [],
    selectedSizes: [],
    selectedColors: [],
    selectedGenders: [],
    selectedCategories: [],
    collapsBrands: true,
    collapsSizes: true,
    collapsColors: true,
    collapsGenders: true,
    collapsCategories: true,
    collapsRange: true,
    value: { min: null, max: null },
}

class Filter extends Component {

    constructor() {
        super();
        this.state = defaultFilters
    }

    componentDidMount() {
        const { connection_id } = this.props;
        //this.props.getAllSearchFilters(connection_id, "");
    }

    componentDidUpdate(prevProps, prevState){
        if (prevProps.openState !== this.props.openState){
            if(this.props.openState === true){
                this.resetFilters()
            }
        }
    }

    closeFilter = () => {
        document.querySelector(".collection-filter").style = "left: -365px";
    }

    resetFilters = () => {
        const {connection_id} = this.props
        this.setState( {
            selectedBrands: [],
            selectedSizes: [],
            selectedColors: [],
            selectedGenders: [],
            selectedCategories: [],
            collapsBrands: true,
            collapsSizes: true,
            collapsColors: true,
            collapsGenders: true,
            collapsCategories: true,
            collapsRange: true,
            value: { min: null, max: null },
        }
        , () => {
            this.props.getAllSearchFilters(connection_id, this.state.selectedCategories);
            
        })
        
    }

    setSearchFilters = () => {
        if (this.state.selectedCategories.length <= 0) {
            toast.error("Please select a category to proceed with search.")
        }
        else {
            const { connection_id, store_id } = this.props;
            
            let options = {
                category_id: this.state.selectedCategories,
                brand_code: this.state.selectedBrands,
                color_code: this.state.selectedColors,
                gender_id: this.state.selectedGenders,
                size_id: this.state.selectedSizes,
                price_start_range: this.state.value.min,
                price_end_range: this.state.value.max,
            }
            this.props.setSearchFilters(options);
            this.props.onSetSidebarOpen(false)
            this.props.history.push('/search')
            this.props.getCategoryItems({
                ...this.state,
                ...options,
                ...{ connection_id, store_id },
            });
        }
    }

    clickcatHandle = (event) => {
        const { connection_id } = this.props
        if (event.target.id === this.state.selectedCategories) {
            this.setState({ selectedCategories: '' }, () => {
                this.resetFilters()
            })

        }
        else {
            this.resetFilters()
            this.setState({ selectedCategories: event.target.id },
                () => {
                    this.props.getAllSearchFilters(connection_id, this.state.selectedCategories);
                })
        }
    }

    clickBrandHandle = (event) => {
        const selected = this.state.selectedBrands;
        this.props.brands.map(brand => {
            if (brand.BRD_CD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {
                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedBrands: selected })
            }
            else return null
        })
    }

    clickGenderHandle = (event) => {
        const selected = this.state.selectedGenders;
        this.props.genders.map(gender => {
            if (gender.GEN_GENDER_CD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {
                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedGenders: selected })
            }
            else return null
        })
    }

    clickColourHandle = (event) => {
        const selected = this.state.selectedColors;
        this.props.colours.map(color => {
            if (color.SKU_VARIANT1_VALCD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {

                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedColors: selected })
            }
            else return null
        })
    }

    clicksizeHandle = (event) => {
        const selected = this.state.selectedSizes;
        this.props.sizes.map(size => {
            if (size.SKU_VARIANT2_VALCD === event.target.id) {
                var index = selected.indexOf(event.target.id);
                if (!selected.includes(event.target.id)) {
                    selected.push(event.target.id)
                }
                else
                    selected.splice(index, 1);
                this.setState({ selectedSizes: selected })
            }
            else return null
        })
    }


    render() {

        const { brandLoading, brands, loading, genders, genderLoading, ranges, rangeLoading, colorLoading, colours, sizesLoading, sizes, categories } = this.props
        const { selectedBrands, selectedGenders, selectedColors, selectedSizes, selectedCategories } = this.state
        if (loading) {
            return (
                <div style={{ 'marginTop': '50vh' }}>
                    <div className="loading-cls"></div>
                </div>
            )
        }
        return (
            <>
                <div className="">
                    {/*brand filter start*/}
                    <div className="filter-header">
                        <img src={filterDefault} style={{ marginLeft: 10 }} alt="img" />
                        <span className="left-side">Search by</span>
                        <img src={closeDefault} className="right-side" onClick={() => this.props.onSetSidebarOpen(false)} alt="img" />
                    </div>
                    <div className={"collection-filter-block"}>
                        <SlideToggle
                            collapsed={this.state.collapsCategories}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>Category {selectedCategories.length > 0 ? "(1)" : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {brandLoading ? <div className="loading-cls"></div> :
                                                categories.map((cat, index) => {
                                                    return (
                                                        <div className="custom-control collection-filter-checkbox" key={index}>
                                                            <label htmlFor={cat.SMH_LEVEL3_CD} onChange={(e) => this.clickcatHandle(e)}>
                                                                <input className="radio_animated" type="radio" id={cat.SMH_LEVEL3_CD} name={cat.SMH_LEVEL3_CD}
                                                                    //  checked={selectedcats.includes(cat.SMH_LEVEL3_CD) ? true : false} />
                                                                    checked={selectedCategories === cat.SMH_LEVEL3_CD ? true : false} />
                                                                {cat.SMH_LEVEL3_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>

                        <SlideToggle
                            onExpanded={() => {
                                if (this.state.selectedCategories.length <= 0) {
                                    toast.error("Please select a category to proceed with search.")
                                }
                            }}
                            collapsed={this.state.collapsBrands}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>brand {selectedBrands.length > 0 ? `(${selectedBrands.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {brandLoading ? <div className="loading-cls"></div> :
                                                brands.map((brand, index) => {
                                                    return (
                                                        <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={brand.BRD_CD} onChange={this.clickBrandHandle}>
                                                                <input className="checkbox_animated" type="checkbox" id={brand.BRD_CD} name={brand.BRD_CD}
                                                                    //  checked={selectedBrands.includes(brand.BRD_CD) ? true : false} />
                                                                    checked={selectedBrands.includes(brand.BRD_CD) ? true : false} />
                                                                {brand.BRD_NAME}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>

                        {/*gender filter start here*/}
                        <SlideToggle
                            onExpanded={() => {
                                if (this.state.selectedCategories.length <= 0) {
                                    toast.error("Please select a category to proceed with search.")
                                }
                            }}
                            collapsed={this.state.collapsGenders}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>Gender {selectedGenders.length > 0 ? `(${selectedGenders.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {genderLoading ? <div className="loading-cls"></div> :
                                                genders.map((gender, index) => {
                                                    return (
                                                        <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={gender.GEN_GENDER_CD} onChange={this.clickGenderHandle}>
                                                                <input className="checkbox_animated" type="checkbox" id={gender.GEN_GENDER_CD} name={gender.GEN_GENDER_CD}
                                                                    //  checked={selectedgenders.includes(gender.GEN_GENDER_CD) ? true : false} />
                                                                    checked={selectedGenders.includes(gender.GEN_GENDER_CD) ? true : false} />
                                                                {gender.GEN_GENDER_NAME}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>


                        {/*size filter start here*/}
                        <SlideToggle
                            onExpanding={() => {

                                if (this.state.selectedCategories.length <= 0) {
                                    toast.error("Please select a category to proceed with search.")
                                }
                            }}
                            collapsed={this.state.collapsSizes}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>Size {selectedSizes.length > 0 ? `(${selectedSizes.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {sizesLoading ? <div className="loading-cls"></div> :
                                                sizes.map((size, index) => {
                                                    return (
                                                        <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={size.SKU_VARIANT2_VALCD} onChange={(e) => this.clicksizeHandle(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={size.SKU_VARIANT2_VALCD} name={size.SKU_VARIANT2_VALUE_DESC}
                                                                    checked={selectedSizes.includes(size.SKU_VARIANT2_VALCD) ? true : false}
                                                                />
                                                                {size.SKU_VARIANT2_VALUE_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>

                        <SlideToggle
                            onExpanding={() => {

                                if (this.state.selectedCategories.length <= 0) {
                                    toast.error("Please select a category to proceed with search.")
                                }
                            }}
                            collapsed={this.state.collapsColors}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>Color {selectedColors.length > 0 ? `(${selectedColors.length})` : ""}</h3>
                                    <div className="collection-collapse-block-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {colorLoading ? <div className="loading-cls"></div> :
                                                colours.map((colour, index) => {
                                                    return (
                                                        <div className="custom-control custom-checkbox collection-filter-checkbox" key={index}>
                                                            <label htmlFor={colour.SKU_VARIANT1_VALCD} onChange={(e) => this.clickColourHandle(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={colour.SKU_VARIANT1_VALCD} name={colour.SKU_VARIANT1_VALUE_DESC}
                                                                    checked={selectedColors.includes(colour.SKU_VARIANT1_VALCD) ? true : false}
                                                                />
                                                                {colour.SKU_VARIANT1_VALUE_DESC}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>

                        <SlideToggle
                            onExpanded={() => {
                                if (this.state.selectedCategories.length <= 0) {
                                    toast.error("Please select a category to proceed with search.")
                                }
                                if (!!ranges && ranges.length <= 0) {
                                    this.onRangeToggle()
                                }
                            }}
                            collapsed={this.state.collapsRange}
                        >
                            {({ toggle, setCollapsibleElement }) => (
                                // <div className={selectedBrands === "" ? 'disabledFilter collection-collapse-block': 'collection-collapse-block'}>
                                <div className="collection-collapse-block">
                                    <h3 className="collapse-block-title" onClick={toggle}>Price Range</h3>
                                    <div className="collection-collapse-block-content block-price-content" ref={setCollapsibleElement}>
                                        <div className="collection-brand-filter">
                                            {rangeLoading ? <div className="loading-cls"></div> :
                                                <div className="custom-control custom-checkbox collection-filter-checkbox">
                                                    <InputRange
                                                        maxValue={parseInt(ranges.MAX_LOT_PRICE) || null}
                                                        minValue={parseInt(ranges.MIN_LOT_PRICE) || null}
                                                        value={this.state.value}
                                                        onChange={value => this.setState({ value })}
                                                        onChangeComplete={this.clickRangeHandle}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )}
                        </SlideToggle>
                    </div>
                </div>
                <div className="filter-bottom">

                    <div className="col-6 text-center" onClick={() => this.resetFilters()}>

                        <button type="submit" className="btn btn-solid" style={{ width: "100%" }}>Clear Selection</button>
                    </div>
                    {/* <div className="col-6 text-center" onClick={() => this.props.handleApplyFilters(this.state)}> */}
                    <div className="col-6 text-center" onClick={() => this.setSearchFilters()}>
                        <button type="submit" className="btn btn-solid" style={{ width: "100%" }}>Look Up</button>
                    </div>

                </div>
            </>
        )
    }
}


const mapStateToProps = state => ({
    brands: state.searchFilters.brand.data,
    brandLoading: state.searchFilters.brand.loading,
    genders: state.searchFilters.gender.data,
    genderLoading: state.searchFilters.gender.loading,
    ranges: state.searchFilters.range.data,
    rangeLoading: state.searchFilters.range.loading,
    colours: state.searchFilters.colour.data,
    colourLoading: state.searchFilters.colour.loading,
    sizes: state.searchFilters.size.data,
    sizesLoading: state.searchFilters.size.loading,
    categories: state.searchFilters.categories.data,
    categoriesLoading: state.searchFilters.categories.loading,
    // colors: getColors(state.data.products),
    // prices: getMinMaxPrice(state.data.products),
    searchFilters: state.searchFilters,
    connection_id: state.tenant.connection_id,
    loading: state.searchFilters.loading,
    selectedsearchFilters: state.searchFilters.searchSelectedFilters,
})


export default compose(
    withRouter,
    connect(
        mapStateToProps,
        { getAllSearchFilters, setSearchFilters, getCategoryItems }
    ))
    (Filter);